import React, { useEffect, useState } from "react";
import { publicAPI, privateAPI } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import jwt_decode from "jwt-decode";
import loginBackground from "../../assets/login/blue-part-login.svg";
import DesktopMenu from "../../common/DesktopMenu/index";
import MobileMenu from "../../common/MobileMenu/index";
import useWindowSize from "../../common/windowSize";
import VisibilityIcons from "./VisibilityIcons";
import NewFooter from "../../common/NewFooter";
import {
  Background,
  LoginBackground,
  LoginBackgroundImage,
  LoginTitle,
  LoginInput,
  LoginButton,
  LoginSubtitle,
  InputWrapper,
} from "./styles";

const ForgotChangePassword = () => {
  const size = useWindowSize();
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState();
  const [resetPassword, setResetPassword] = useState({});
  const [user, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    password: false,
    repeatedPassword: false,
  });

  const sendResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!resetPassword.oldPassword)
      return [toast.error("Password is empty"), setLoading(false)];
    if (!resetPassword.password)
      return [toast.error("New password is empty"), setLoading(false)];
    if (!resetPassword.repeatedPassword)
      return [toast.error("Repeated password is empty"), setLoading(false)];
    if (resetPassword.password !== resetPassword.repeatedPassword)
      return [toast.error("Passwords doesn't match"), setLoading(false)];

    try {
      const token = getCookie("token");
      const decoded = jwt_decode(token);
      delete resetPassword.repeatedPassword;

      await privateAPI.put(`/auth/bacchus/client/user/newpassword/${decoded.id}`, resetPassword );

      setResetPassword({});
      toast.success("Successfully changed password.");
      navigate("/profile");
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  const sendForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!user.username)
      return [toast.error("Email is empty"), setLoading(false)];

    try {
      await publicAPI.put(`/public/bacchus/user/forgot-password`, user);

      navigate("/");
    } catch (error) {
      setLoading(false);
      if (error.request.status !== 500)
        return toast.error(`${error.response.data.message}`);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    setIsForgotPassword(window.location.href.includes("forgot-password"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background>
        <LoginBackground>
          <LoginBackgroundImage src={loginBackground} />
          <LoginTitle>
            {isForgotPassword ? "Forgot password" : "Change Password"}
          </LoginTitle>
          {isForgotPassword && (
            <LoginSubtitle>
              Send us the email with which you registered with us, we will
              contact you as soon as possible.
            </LoginSubtitle>
          )}
          {isForgotPassword ? (
            <InputWrapper>
              <LoginInput
                type="email"
                placeholder="Enter your e-mail"
                disabled={loading}
                onChange={(e) => setEmail({ ...user, username: e.target.value })}
              />
            </InputWrapper>
          ) : (
            <React.Fragment>
              <InputWrapper>
                <LoginInput
                  type={showPassword?.oldPassword ? "text" : "password"}
                  placeholder="Old password"
                  disabled={loading}
                  onChange={(e) =>
                    setResetPassword({
                      ...resetPassword,
                      oldPassword: e.target.value,
                    })
                  }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.oldPassword}
                  typePassword={"oldPassword"}
                />
              </InputWrapper>
              <InputWrapper>
                <LoginInput
                  type={showPassword.password ? "text" : "password"}
                  placeholder="New password"
                  disabled={loading}
                  onChange={(e) =>
                    setResetPassword({
                      ...resetPassword,
                      password: e.target.value,
                    })
                  }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.password}
                  typePassword={"password"}
                />
              </InputWrapper>
              <InputWrapper>
                <LoginInput
                  type={showPassword.repeatedPassword ? "text" : "password"}
                  placeholder="Repeat new password"
                  disabled={loading}
                  onChange={(e) =>
                    setResetPassword({
                      ...resetPassword,
                      repeatedPassword: e.target.value,
                    })
                  }
                />
                <VisibilityIcons
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  isVisible={showPassword?.repeatedPassword}
                  typePassword={"repeatedPassword"}
                />
              </InputWrapper>
            </React.Fragment>
          )}
          <LoginButton
            type="submit"
            value="Submit"
            disabled={loading}
            onClick={(e) =>
              isForgotPassword ? sendForgotPassword(e) : sendResetPassword(e)
            }
            onKeyDown={(e) => {
              e.key === 13 ?? isForgotPassword
                ? sendForgotPassword(e)
                : sendResetPassword(e);
            }}
          >
            {loading ? "Loading..." : isForgotPassword ? "Send" : "Change"}
          </LoginButton>
          <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </LoginBackground>
      </Background>
      <NewFooter />
    </>
  );
};
export default ForgotChangePassword;
